module.exports = __webpack_public_path__ + "img/genre2.95fcd0c5.svg";